export default "__VITE_ASSET__wCBn7vml__"